/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.7",
    versionName: "0.2.0-nightly.2026.2.7",
    versionChannel: "nightly",
    buildDate: "2026-02-07T00:11:59.857Z",
    commitHash: "beaa5837526c7554194c33ea2094ca65261a673f",
};
